const customer_message_rep_reducer = (state = "", action) => {
	switch(action.type) {

		case 'UPDATEREPCUSTOMERMSG':
			return action.payload;

		default:
			return state;
	}
}

export default customer_message_rep_reducer;